import { useDictionaryContext } from '3-foundation/Dictionary/DictionaryContext';
import { UI_GoToTopNavigation } from 'ui/components/3-organisms/GoToTopNavigation/GoToTopNavigation';

export const GoToTopNavigation = () => {
	const dictionary = useDictionaryContext();
	const toTopTitle = dictionary.getAction('ToTop');
	return <UI_GoToTopNavigation title={toTopTitle} />;
};
